










import { Component, Prop, Vue } from 'vue-property-decorator';
import { productVariantHolderFragments } from '@/queries/ProductVariantHolderFragments';
import HolderForm from '@/components/ProductVariantHolder/HolderForm.vue';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_ProductVariantHolderCreate } from '@/queries/global';
import { GQL_createProductVariantHolderVariables } from '@/queries/__generated__/createProductVariantHolder';
import SPopup from '@/components/UI/Popup/SPopup.vue';
import gql from 'graphql-tag';

const CREATE_PRODUCT_VARIANT_HOLDER = gql`
  mutation createProductVariantHolder($productVariantHolder: ProductVariantHolderCreate!) {
    createProductVariantHolder(input: { productVariantHolder: $productVariantHolder }) {
      productVariantHolder {
        ...productVariantHolderFragments
      }
    }
  },
  ${productVariantHolderFragments}
`;

@Component({
  components: {
    HolderForm,
  },
})
export default class HolderNew extends Vue {
  @SmartQuery<HolderNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) private currentUnit!: GQL_currentUnit;

  @Prop() private parentPopup!: SPopup

  private CREATE_PRODUCT_VARIANT_HOLDER = CREATE_PRODUCT_VARIANT_HOLDER;

  private data: GQL_ProductVariantHolderCreate = {
    name: '',
    attributeName: '',
    description: null,
    unitId: '',
    variants: [],
  };

  public formatDataForMutation(productVariantHolder: GQL_ProductVariantHolderCreate): GQL_createProductVariantHolderVariables {
    return {
      productVariantHolder: {
        unitId: productVariantHolder.unitId,
        name: productVariantHolder.name,
        attributeName: productVariantHolder.attributeName,
        description: productVariantHolder.description,
        variants: productVariantHolder.variants.map(variant => {
          return {
            name: variant.name,
            productId: variant.productId,
          };
        }),
      },
    };
  }
}
